import { render, staticRenderFns } from "./BetNumListView.vue?vue&type=template&id=71fd8c88&scoped=true"
import script from "./BetNumListView.vue?vue&type=script&lang=js"
export * from "./BetNumListView.vue?vue&type=script&lang=js"
import style0 from "./BetNumListView.vue?vue&type=style&index=0&id=71fd8c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd8c88",
  null
  
)

export default component.exports